var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_SET_CUSTOMERS_APP = 'api/v2/washdayapp/customers';
const GET_SET_CUSTOMERS = 'api/customer';
export const getList = function (params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
                signal: (options === null || options === void 0 ? void 0 : options.signal) || params.signal || undefined
            };
            const queryParams = generateQueryParamsStr(['searchTerm', 'name', 'phone', 'email', 'fromDate', 'toDate', 'limit', 'pageNum', 'createdIn', 'includeOrderMetrics'], params);
            return yield this.axiosInstance.get(`${GET_SET_CUSTOMERS}?${queryParams}`, config);
        }
        catch (error) {
            if (error instanceof Error && (error.name === 'AbortError' || error.name === 'CanceledError')) {
                console.log('Request was cancelled');
                throw error;
            }
            console.error('Washday SDK - Error fetching customers:', error);
            throw error;
        }
    });
};
export const getCustomerById = function (customerId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_CUSTOMERS}/${customerId}`, config);
            return response.data;
        }
        catch (error) {
            console.error('Error fetching customer:', error);
            throw error;
        }
    });
};
export const getCustomerHighlightsById = function (customerId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_CUSTOMERS}/${customerId}/highlights`, config);
            return response.data;
        }
        catch (error) {
            console.error('Error fetching getCustomerHighlightsById:', error);
            throw error;
        }
    });
};
export const getCustomerOrders = function (customerId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr(['limit', 'pageNum'], params);
            return yield this.axiosInstance.get(`${GET_SET_CUSTOMERS}/${customerId}/orders?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getCustomerHighlightsById:', error);
            throw error;
        }
    });
};
export const getCustomerByIdCustomersApp = function (customerId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_CUSTOMERS_APP}/${customerId}`, config);
        }
        catch (error) {
            console.error('Error fetching customer:', error);
            throw error;
        }
    });
};
export const getCustomerLoyaltyHistory = function (customerId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_CUSTOMERS}/${customerId}/loyalty-history`, config);
        }
        catch (error) {
            console.error('Error fetching getCustomerLoyaltyHistory:', error);
            throw error;
        }
    });
};
